var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRubric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-200v-560q0-33 23.5-56.5T240-840h480q33 0 56.5 23.5T800-760v240q0 33-23.5 56.5T720-440H240v80h160q17 0 28.5 11.5T440-320q0 17-11.5 28.5T400-280H240v80h160q17 0 28.5 11.5T440-160q0 17-11.5 28.5T400-120H240q-33 0-56.5-23.5T160-200Zm456-32 114-114q11-11 28-11t28 11q11 11 11 28t-11 28L644-148q-12 12-28 12t-28-12l-56-56q-11-11-11-28t11-28q11-11 28-11t28 11l28 28ZM240-520h200v-80H240v80Zm280 0h200v-80H520v80ZM240-680h200v-80H240v80Zm280 0h200v-80H520v80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubric);
export default __webpack_public_path__ + "static/media/rubric.3f44c28f44d53af0338cd10a533da7c8.svg";
export { ForwardRef as ReactComponent };